/**
 * EventPlannerSend
 *
 * Purpose: handles sending + sharing the planner
 */
var EventPlannerSend = function() {};

EventPlannerSend.prototype = {
  forms : null,
  restoreLink : '',
  plannerShareLinks : null,
  init : function() {
    this.forms = document.querySelectorAll('.send-planner-form form');
    this.client = new XMLHttpRequest();
    this.plannerShareLinks = document.querySelectorAll('.planner-share-links a[data-network]');
    return this;
  },

  setLink : function(link) {
    this.restoreLink = link;
    // update all forms with the link
    if(this.forms) {
      this.forms.forEach(
          function(form) {
            if(form.closest('.event-planner-dashboard')) {
              form.elements['RestoreLink'].value = window.location.href;
            } else {
              form.elements['RestoreLink'].value = link;
            }
          }
      );
    }
    this.updateShareLinks(link);
  },

  updateShareLinks : function(link) {
    var _self = this;
    if(this.plannerShareLinks) {
      this.plannerShareLinks.forEach(
          function(shareLink) {
            if(shareLink.closest('.event-planner-dashboard')) {
              shareLink.href =_self.addNetworkLink(window.location.href, shareLink.dataset.network);
            } else {
              shareLink.href =_self.addNetworkLink(link, shareLink.dataset.network);
            }
          }
      );
    }
  },

  addNetworkLink : function(link, network) {
    switch(network) {
      case 'facebook':
        return 'https://facebook.com/sharer/sharer.php?u=' + encodeURIComponent(link);
        break;
      case 'twitter':
        return 'https://twitter.com/intent/tweet/?url=' + encodeURIComponent(link);
        break;
      default:
        return '';
        break;
    }
  },

  // handle submission of send planner form
  handle : function() {
    var _self = this;
    this.forms.forEach(
        function(form) {
          _self.handleForm(form);
        }
    );
  },


  default_success: 'Your planner was sent successfully',
  default_error: 'Your planner could not be sent at the current time',
  client: null,

  handleForm: function(form) {
    var _self = this;
    form.addEventListener(
      'submit',
      function(e) {
        e.preventDefault();
        return _self.submitForm(this);
      }
    );
  },

  submitForm: function(form) {
    var _self = this;

    this.client.addEventListener(
      "load",
      function(event) {
        var success = (this.readyState == 4 && this.status == 200);
        _self.addFormMessage(form, success ? 'success' : 'error');
      }
    );
    this.client.addEventListener(
      "error",
      function( event ) {
        _self.addFormMessage(form, 'error');
      }
    );
    this.client.addEventListener(
      "abort",
      function( event ) {
        _self.addFormMessage(form, 'error');
      }
    );

    // create the formdata
    var formdata = new FormData( form );
    formdata.append('ajax', 1);

    // hide all messages
    this.hideMessages(form);

    // send
    this.client.open("POST", form.action);
    this.client.send(formdata);
  },

  hideMessages : function(form) {
    var success = form.querySelector('.message.good');
    var failure = form.querySelector('.message.bad');
    failure.style.display = 'none';
    success.style.display = 'none';
  },

  addMessageToElement : function(elm, message) {
    if(message) {
      var tgt = elm.dataset.target;
      if(tgt) {
        var telm = elm.querySelector(tgt);
        if(telm) {
          telm.textContent = message;
          telm.style.display = 'block';
          telm.setAttribute('aria-hidden','false');
          return true;
        }
      }
      elm.textContent = message;
    }
  },

  addFormMessage : function(form, type) {
    try {
      form.elements['PlannerCaptcha'].value = '';
      form.elements['Email'].focus();
    } catch (e) {}
    var success = form.querySelector('.message.good');
    var failure = form.querySelector('.message.bad');
    var message = this.client.getResponseHeader('X-Response-Message');
    if(type == 'success') {
      this.addMessageToElement(success, message);
      success.style.display = 'block';
      success.setAttribute('aria-hidden','false');
      failure.style.display = 'none';
      failure.setAttribute('aria-hidden','true');
    } else {
      this.addMessageToElement(failure, message);
      failure.style.display = 'block';
      failure.setAttribute('aria-hidden','false');
      success.style.display = 'none';
      success.setAttribute('aria-hidden','true');
    }
  }

}
